export default {
  glob_async_error: 'Operation impossible',
  glob_autoplay_on: 'Auto-play enabled',
  glob_autoplay_off: 'Auto-play disabled',
  glob_btn_accept: 'Accept',
  glob_btn_refuse: 'Refuse',
  glob_btn_settings: 'Settings',
  glob_cancel: 'Cancel',
  glob_close: 'Close',
  glob_hellosir: 'Hello {userName}',
  glob_home: 'Home page',
  glob_home_long: 'Back to home page',
  glob_media_load_error: 'Unable to read this content',
  glob_notification_subscribe: `Subscribe`,
  glob_home_all_contents: 'All your content',
  glob_home_all_universes: 'All your collections',
  glob_home_featured: 'Featured',
  glob_home_search: 'Search',
  page_layout_error_404_title: 'This page does not exist',
  page_layout_error_404_text:
    'The page you are trying to access does not exist or has been moved.',
  page_layout_error_500_title: 'Oh no...',
  page_layout_error_500_text:
    'An error prevents us from displaying this page correctly. Our teams are notified of the incident and do everything possible to resolve the problem. If the problem persists, please contact support',
  page_layout_error_support: 'Contact support',
  page_login_connection: 'Login to get started',
  page_register_activate_createaccount: 'Activate your account',
  page_register_activate_access: 'Access to {to}',
  page_register_activate_input_code:
    'Enter the confirmation code you received by e-mail',
  page_register_activate_give_code:
    'Please enter the 6 digits received by email',
  page_register_activate_submit: 'Activate my account',
  page_register_account_create: 'Create an account',
  page_register_access: 'Access to {to}',
  page_register_subscribe: 'Sign up to access',
  page_register_already_account: 'I already have an account',
  page_settings_title: 'Privacy settings',
  page_settings_cookie_session: 'Session Cookies',
  page_settings_cookie_session_desc:
    '{cookie_session_subtitle} They may contain, for example, cookies that collect session IDs and identification data, cookies that allow us to customize the site interface or some audience measurement cookies. This category also contains cookies that allow us to comply with our legal obligations, including ensuring a secure online environment (for example, by detecting repetitive connection failures to prevent unauthorized people from accessing your account).',
  page_settings_cookie_session_subtitle:
    'Mandatory cookies, necessary for the proper functioning of the site',
  page_settings_metrics_trackers_unecessary:
    'This application does not collect any of your personal data',
  page_settings_metrics_trackers_notify_enabled:
    'Tracking devices have been activated',
  page_settings_metrics_trackers_notify_disabled:
    'Tracking devices have been deactivated',
  glob_sidebar_settings: 'Settings',
  glob_sidebar_moreabout: 'About us',
  glob_sidebar_moreabout_legals: 'Legal Notice',
  glob_sidebar_moreabout_terms: 'Terms and conditions of use',
  glob_sidebar_moreabout_data: 'Personal data policy',
  glob_sidebar_moreabout_versions: 'Versions',
  glob_sidebar_support: 'Help and Support',
  glob_sidebar_exit: 'Logout',
  cp_langswitcher_title: 'Change language',
  cp_footer_company: 'Mediameeting',
  cp_footer_companysubtitle: 'Voice Business Company',
  cp_footer_link_terms: 'Terms and conditions of use',
  cp_footer_link_legals: 'Legal Notice',
  cp_footer_link_data: 'Personal data',
  cp_footer_link_settings: `Settings`,
  cp_footer_link_needsupport: 'Contact support',
  cp_footer_lang_title: 'Change language',
  cp_footer_lang_updated: 'Updated language',
  cmp_btnplay_live: 'Launch the live',
  cmp_btnplay_play: 'Listen',
  cmp_btnplay_read: 'Read',
  cmp_btnplay_watch: 'Watch',
  cmp_btnplay_stop: 'Stop',
  cmp_btnplay_error: 'Error',
  cmp_btnplay_loading: '...',
  cmp_carticleviewcontent_author: 'By {author}',
  cmp_carticleviewcontent_pubdate: 'Published on {publishedAt}',
  cmp_carticleviewconversation_close: 'Close the conversation area',
  cmp_cuniverslide_viewall: 'View all',
  cmp_cnocontent_universe: 'Content does not exist in this session',
  cmp_cinnerslide_ccardviewmore_text: 'See more',
  cmp_cinnerslide_loading: 'Loading your content...',
  cmp_cinnerslide_nomore_content: `That's all for now`,
  cmp_cinnerslide_nocontent: 'There is nothing here at the moment',
  cmp_cheadingconversation_empty: `We are a community, let's talk together !`,
  cmp_carticleview_carticleviewcontent_conversation:
    'A discussion space is open !',
  cmp_carticleview_carticleviewcontent_placeholder: 'Your comment',
  cmp_carticleview_carticleviewcontent_mobile_discuss: 'Chat',
  cmp_carticleview_carticleviewcontent_mobile_documents_shared: 'Shared files',
  cmp_carticleview_carticleviewcontent_mobile_consult: 'Check',
  cmp_carticleview_carticleviewcontent_documents:
    'Useful documents are waiting for you',
  cmp_carticleview_carticleviewcontent_gallery: 'Open the media gallery',
  cmp_carticleview_carticleviewcontent_poll: 'Take the survey',
  cmp_carticleview_carticleviewcontent_mobile_program: 'In schedule',
  cmp_carticleviewconversation_areazone: 'Live chat area',
  cmp_carticleviewconversation_launchconversation:
    'Your colleagues are following the programme in the discussion area. Join the conversation!',
  cmp_cpersistentplayer_tab_episodes: 'Chapters',
  cmp_cpersistentplayer_tab_episodesempty: 'This content has no episodes yet',
  cmp_cpersistentplayer_tab_documents: 'Documents and links',
  cmp_cpersistentplayer_tab_documentsempty:
    'This content has no supporting documents',
  cmp_cpersistentplayer_tab_suggestions: 'To listen again',
  cmp_cpersistentplayer_tab_suggestionsempty: 'No suggestions',
  cmp_cpersistentplayer_suggestionslist_main: 'Featured content',
  cmp_cpersistentplayer_cdocumentslist_documents: 'Useful documents',
  cmp_cpersistentplayer_cdocumentslist_links: 'Useful links',
  cmp_cpersistentplayer_cdocumentslist_documentnotitle: 'Untitled document',
  cmp_cpersistentplayer_cdocumentslist_documentdownloading:
    'Downloading the current document',
  cmp_cpersistentplayer_cdocumentslist_documentopening:
    'Opening the external link',
  cmp_cpersistentplayer_cdocumentslist_documentdownloaderror:
    'Unable to decode this document',
  cmp_cpersistentplayer_cdocumentslist_documentopenerror:
    'Unable to decode this external link',
  cmp_cpersistentplayer_dialog_see_content: 'See content',
  cmp_cpersistentplayer_wvolumecontroller_popup_title: 'Setup volume',
  cp_wathsafari_altlogo: 'iOs sharing icon',
  cp_wathsafari_downloadapp: 'Download the application',
  cp_search_all: 'All',
  cp_search_btn: 'Search',
  cp_search_error: 'Error during search',
  cp_search_popular: 'Most popular',
  cp_search_placeholder: 'Search for content, a speaker ...',
  cp_search_results: 'result(s) for your search',
  cp_search_no_content: 'Sorry, no results match your search',
  cp_search_spell:
    'Check the spelling of the entered words or try new terms for your search.',
  cp_wathsafari_instruct1: 'To install the application, click on',
  cp_wathsafari_instruct2: 'then add to the home screen',
  cp_wauthenticator_index_create: 'Create an account',
  cp_wauthenticator_index_dislaylogin: 'You are not',
  cp_wauthenticator_index_next: 'Next',
  cp_wauthenticator_index_login: 'Login',
  cp_wauthenticator_index_or: 'OR',
  cp_wauthenticator_index_cantconnect: "I can't connect",
  cp_wauthenticator_index_informcgu:
    'By logging in, you accept the general terms and conditions of use',
  cp_wauthenticator_login_winputlogin_id: 'Login ID',
  cp_wauthenticator_login_winputlogin_placeholderphone: 'Phone number',
  cp_wauthenticator_login_winputlogin_placeholderemail: 'adress@email.com',
  cp_wauthenticator_login_winputlogin_placeholderboth: 'Your login name',
  cp_wauthenticator_login_winputlogin_hintfpemail:
    'Enter the e-mail address you entered when you registered.',
  cp_wauthenticator_login_winputlogin_hintfpphone:
    'Indicate the telephone number you gave when you registered',
  cp_wauthenticator_login_winputlogin_hintfpboth:
    'Enter your email address or phone number',
  cp_wauthenticator_login_winputlogin_hintemail:
    'Your professional email address',
  cp_wauthenticator_login_winputlogin_hintphone: 'Your phone number',
  cp_wauthenticator_login_winputlogin_hintboth: 'Your email or phone number',
  cp_wauthenticator_login_winputlogin_idrequired: 'You must enter a login name',
  cp_wauthenticator_login_winputlogin_idformatemail:
    'You must enter a valid email address (example@adress.com)',
  cp_wauthenticator_login_winputlogin_idformatphone:
    'You must enter a valid telephone number (10 digits)',
  cp_wauthenticator_login_winputlogin_idformatboth:
    'You must enter a valid email address or phone number',
  cp_wauthenticator_login_winputlogin_errinvalid: 'Invalid login',
  cp_wauthenticator_login_winputphoneprefix_choose:
    'Select your mobile area code',
  cp_wauthenticator_password_winputotp_desc:
    'We have just sent a 4-digit login code to the number associated with your account. Please enter this code code below',
  cp_wauthenticator_password_winputotp_descemail:
    'We have just sent a 4-digit login code to the e-mail address associated with your account. Please enter this code below.',
  cp_wauthenticator_password_winputotp_nocode: `Didn't receive a login code ?`,
  cp_wauthenticator_password_winputotp_retrycountdown:
    'Request a new code (wait {countdown}s)',
  cp_wauthenticator_password_winputotp_retry: 'Request a new code',
  cp_wauthenticator_password_winputpassword_hint: 'Your secure password',
  cp_wauthenticator_password_winputpassword_label: 'Password',
  cp_wauthenticator_password_winputpassword_err_required:
    'You must enter a password',
  cp_wauthenticator_password_winputpassword_err_length:
    'The password must contain more than 4 characters',
  cp_wauthenticator_password_wpasswordreset_title: `Don't remember your password ?`,
  cp_wauthenticator_password_wpasswordreset_text: `Don't panic, enter your email address below and follow the instructions.`,
  cp_wauthenticator_password_wpasswordreset_submit: 'Reset password',
  cp_wbuttonlike_add: 'Add to favourites',
  cp_wbuttonlike_remove: 'In your favourites',
  cp_wbuttonplay_listen: 'Listen now',
  cp_wbuttonplay_error: 'Reading error',
  cp_wbuttonplay_pause: 'Pause',
  cp_wbuttonplay_stop: 'Stop',
  cp_wbuttonplay_read: 'Read now',
  cp_wfeedbackpopup_back: 'Resume playback',
  cp_wfeedbackpopup_close: 'Close',
  cp_wfeedbackpopup_error: 'Please fill in the fields correctly',
  cp_wfeedbackpopup_listen: 'You can listen to your message again.',
  cp_wfeedbackpopup_max_duration: `You can record up to {0} minute(s) and {1} second(s).`,
  cp_wfeedbackpopup_max_duration_less: `You can record up to {0} second(s).`,
  cp_wfeedbackpopup_max_duration_exact: `You can record up to {0} minute(s).`,
  cp_wfeedbackpopup_notallowed: `Unable to record a dedication without microphone permission.`,
  cp_wfeedbackpopup_record_ready: 'Your recording is ready!',
  cp_wfeedbackpopup_required: '* = Required field(s)',
  cp_wfeedbackpopup_send: 'Send',
  cp_wfeedbackpopup_thanks: 'Thank you !',
  cp_wfeedbackpopup_title: 'Record a message',
  cp_wformresetpassword_one: `Your access to {appName} is administered from your company's SSO login.`,
  cp_wformresetpassword_two: `To connect, return to the authentication page and click on the CONNECT button. Use your professional login details (Microsoft, Google, etc.).`,
  cp_wformresetpassword_three: `Once logged in, you'll be redirected to {appName}.`,
  cp_wnavigationdrawer_index_softwareversion: 'Software version',
  cp_wnavigationdrawer_index_interfaceversion: 'Interface version',
  cp_wnavigationdrawer_index_spokeversion: 'Spoke version',
  cp_wregister_index_give_name: 'Please provide your name',
  cp_wregister_index_name: 'Your name',
  cp_wregister_index_email: 'Email address',
  cp_wregister_index_email_hint: 'Your professional email address',
  cp_wregister_index_password: 'Password',
  cp_wregister_index_password_hint: 'The password you need to sign in',
  cp_wregister_index_password_length:
    'Your password must be at least 4 characters long',
  cp_wregister_index_confirm: 'Confirm',
  cp_wregister_index_finish_subscribe: 'Finish registration',
  cp_wregister_index_login_required: 'You must fill in a login',
  cp_wregister_index_email_bad_format: 'You must fill in a valid e-mail adress',
  cp_wscreenloader_loading: 'Loading in progress',
  cp_wscreenloader_appdown_title: 'Oh no...',
  cp_wscreenloader_appdown_description:
    'The application is not responding. We will automatically try to connect you again in a few moments, do not leave this page.',
  cp_wscreenloader_appdown_support: 'If the problem persists, contact support',
  cp_wscreenloader_appdown_reconnectionattempt:
    'Attempt to reconnect in {countdown}.',
  cp_simplesupport_content:
    'In case of technical problems accessing {appName}, please contact our dedicated support. We will answer your request as soon as possible.',
  cp_simplesupport_defaultsubject: 'Technical problem on {appName}',
  cp_simplesupport_writeus: `{address}`,
  cp_updatewebapp_title: 'A new version is available',
  cp_updatewebapp_updating: 'Updating in progress...',
  cp_updatewebapp_button: 'Update',
  cp_wfilters_multiple_filter: 'Filter',
  cp_wfilters_multiple_filters_desc: 'Find all your favorite content here',
  cp_wfilters_multiple_reset: 'Reset',
  cp_wfilters_multiple_save: 'Save',
  cp_filters_solo_selectall: 'All',
  cp_wfilters_date: 'Date',
  cp_wfilterstags_filter_by: 'Filter by {filterName}',
  cp_wfilterstags_other_tags: '(+{count} others)',
  cp_wrgpdmodal_title: 'Cookie policy',
  cp_wrgpdmodal_text:
    'By clicking on ACCEPT or by continuing navigation, you acknowledge that you have read and accept without reservation the {cgv_link}, the {pol_link} and the use of cookies necessary for the proper functioning of the web application.',
  cp_wrgpdmodal_termslink: 'General Terms and Conditions of Use',
  cp_wrgpdmodal_datalink: 'Privacy Policy',
  cp_wrgpdmodal_usage_opts_1:
    'Enhance your user experience by personalizing features and remembering your choices.',
  cp_wrgpdmodal_usage_opts_2:
    'Measuring the audience by tracking the number of visits and understanding how you find our site.',
  cp_wrgpdmodal_usage_opts_3:
    'Measure audience engagement and site statistics to understand how our services are used',
  cp_wsuggestioncard_see_more: 'See more',
  cp_wsuggestionmodal_cancel: 'Cancel',
  cp_wsuggestionmodal_listen: 'Listen',
  cp_wsuggestionmodal_next_in: 'Coming up in',
  cp_wsuggestionmodal_other: 'Looking for something else?',
  cp_wsuggestionmodal_theme: 'In the same theme ...',
  st_auth_activateaccount_success: 'Your account has been activated',
  st_auth_activateaccount_err:
    'Operation impossible. Contact your service representative.',
  st_auth_asknewpassword_success: 'Please check your mailbox',
  st_auth_asknewpassword_err: 'Error, contact support',
  st_auth_authenticate_err: 'Impossible to authenticate yourself',
  st_auth_authenticatewithprovider_err: 'Cannot connect, contact support',
  st_auth_logout_success: 'You are well disconnected',
  st_auth_notifywelcome_anonymous: 'Welcome to {appname}',
  st_auth_notifywelcome_identified: 'Welcome {name}',
  st_auth_otpcreate_success: 'You have just received your code',
  st_auth_otpcreate_errflood: 'Try again in a minute',
  st_auth_otpcreate_errunknown: 'Error, please contact support',
  st_auth_otpvalidate_errmaxtries: 'Maximum number of tests reached',
  st_auth_otpvalidate_errwrong: 'The code entered is invalid',
  st_auth_register_success: 'Your account has been created',
  st_auth_register_err400: 'Please check the form',
  st_auth_register_err403: 'The domain of the email address is not allowed',
  st_auth_register_err409: 'An account already exists with this address',
  st_auth_resetpassword_success: 'Your password has been updated',
  st_auth_resetpassword_err: 'Operation impossible. Contact support',
  st_contents_react_success: 'Content added to favourites',
  ...require('~/excentrics/lang/en-GB').default,
}
